import { render, staticRenderFns } from "./GameReview.vue?vue&type=template&id=2526fe36"
import script from "./GameReview.vue?vue&type=script&lang=js"
export * from "./GameReview.vue?vue&type=script&lang=js"
import style0 from "./GameReview.vue?vue&type=style&index=0&id=2526fe36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports